import { IframeHeightStrategy } from '../Strategies/iFrameHeightStrategy'

export class FixedHeightStrategy extends IframeHeightStrategy {
  getHeight() {
    return 600
  }
}

export class AlternativeHeightStrategy extends IframeHeightStrategy {
  getHeight() {
    return 100
  }
}